import * as React from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import styled from "@emotion/styled";
import EditIcon from "@assets/Edit";
import DeleteIcon from "@assets/Delete";
import DuplicateIcon from "@assets/Duplicate";

export type Mode = "edit" | "delete";

const MenuStyled = styled(Menu)`
  border: 1px solid #e2e6e8;
`;
const SelectMenu = styled(MenuItem)`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 4px;
  border: 0;
  background: #fff;
  margin: 8px 4px;
  color: #172882;
  & > :first-of-type {
    box-sizing: border-box;
    height: 16px;
  }
`;

export interface Command {
  execute(): void;
}

export interface CommandContext<T extends { id: string | number }> {
  setOpenDialog: (open: boolean) => void;
  setFieldInitialValues: (values: T) => void;
  setId: (id: string) => void;
  setIsEdit: (isEdit: boolean) => void;
  row: T;
}

export class EditCommand<T extends { id: string | number }> implements Command {
  private context: CommandContext<T>;

  constructor(context: CommandContext<T>) {
    this.context = context;
  }

  execute() {
    this.context.setOpenDialog(true);
    this.context.setFieldInitialValues(this.context.row);
    this.context.setId(this.context.row.id.toString());
    this.context.setIsEdit(true);
  }
}

export class DuplicateCommand<T extends { id: string | number }> implements Command {
  private context: CommandContext<T>;

  constructor(context: CommandContext<T>) {
    this.context = context;
  }

  execute() {
    this.context.setOpenDialog(true);
    this.context.setFieldInitialValues(this.context.row);
    this.context.setId(this.context.row.id.toString());
    this.context.setIsEdit(false);
  }
}

export class DeleteCommand<T extends { id: string | number }> implements Command {
  private context: CommandContext<T>;

  constructor(context: CommandContext<T>) {
    this.context = context;
  }

  execute() {
    this.context.setId(this.context.row.id.toString());
    this.context.setOpenDialog(true);
  }
}

type Options = {
  label: string
  key: string
  icon: JSX.Element
}


export interface HoverMenuProps {
  id: number;
  commands: { [key: string]: Command };
  options: Options[]
}

export default function HoverMenu({ commands, options }: HoverMenuProps) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const OnMenuItemClicked = (mode: string) => {
    handleClose();
    // onItemClick(id, mode);
    if (commands[mode]) {
      commands[mode].execute();
    }
  };

  return (
    <div>
      <IconButton
        aria-label='more'
        id='long-button'
        aria-controls={open ? "long-menu" : undefined}
        aria-expanded={open ? "true" : undefined}
        aria-haspopup='true'
        onClick={handleClick}
      >
        <MoreVertIcon style={{ fill: "#172882" }} />
      </IconButton>
      <MenuStyled
        id='long-menu'
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {
          options.map((option) => (
            <SelectMenu key={option.key} onClick={() => OnMenuItemClicked(option.key)} disableRipple>
              {option.icon}
              <div>{option.label}</div>
            </SelectMenu>
          ))
        }
      </MenuStyled>
    </div>
  );
}





// options here



export const BehaviorMenuOptions: Options[] = [{
  label: "Edit",
  key: "edit",
  icon: <EditIcon />
}
  , {
  label: "Delete",
  key: "delete",
  icon: <DeleteIcon />
}]


export const BehaviorCatMenuOptions: Options[] = [{
  label: "Edit",
  key: "edit",
  icon: <EditIcon />
}, 
{
  label: "Duplicate",
  key: "duplicate",
  icon: <DuplicateIcon />
},
{
  label: "Delete",
  key: "delete",
  icon: <DeleteIcon />
}]
